import StoreStudent from "components/module/storeStudent"

const ClassStoreStudentPage = () => {
  return <StoreStudent />
}

export default ClassStoreStudentPage
